module.exports = __webpack_public_path__ + "static/media/ballgame.5c6a0720.jpg";